import { useQuery } from '@tanstack/react-query';

import { searchTracks } from '@/api/track';
import type { Track } from '@/types';

/** Deezer track search, gated on a 2+ char query. */
export function useSearchTracks(query: string) {
  const trimmed = query.trim();
  return useQuery<Track[], Error>({
    queryKey: ['search-tracks', trimmed],
    queryFn: ({ signal }) => searchTracks(trimmed, signal),
    enabled: trimmed.length >= 2,
    staleTime: 30_000,
  });
}
